<template>
  <v-card class="intern-expansion-panel pb-2 pt-2 px-2" flat tile>
    <v-card class="d-flex justify-end" flat tile>
      <v-btn small class="px-2 white--text" color="grey darken-3" @click="handleAddNewItem">
        Adicionar
        <v-icon class="ml-2" small>add</v-icon>
      </v-btn>
    </v-card>

    <v-expansion-panels v-for="(item, index) in value" :key="index" hover focusable @change="changeInputOrderBy(index)">
      <v-expansion-panel class="mt-2">
        <v-expansion-panel-header>
          <span class="my-0 pl-2 text-subtitle-2 font-weight-medium grey--text text--darken-3">{{ item.label }}</span>
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <v-card class="py-2 px-2" flat tile>
            <v-row @input="changeInputOrderBy(index)">
              <v-col cols="12" class="my-0 py-0 pr-3 d-flex justify-end">
                <v-icon color="red" small @click="handleRemoveItem(index)">delete</v-icon>
              </v-col>

              <v-col cols="12">
                <v-text-field class="mt-0" color="grey darken-3" label="Label" v-model="item.label" dense hide-details />
              </v-col>

              <v-col cols="6">
                <v-switch v-model="item.hasConditions" label="hasConditions" dense hide-details class="py-0 my-0" color="grey darken-3" />
              </v-col>

              <v-col cols="6">
                <v-switch v-model="item.visible" label="visible" dense hide-details class="py-0 my-0" color="grey darken-3" />
              </v-col>

              <v-col cols="6">
                <v-switch v-model="item.readonly" label="readonly" dense hide-details class="py-0 my-0" color="grey darken-3" />
              </v-col>

              <v-col cols="6">
                <v-switch
                  v-model="confirmMessage[index]"
                  label="confirmMessage"
                  dense
                  hide-details
                  class="py-0 my-0"
                  color="grey darken-3"
                  @change="toggleConfirmMessage(item, index)"
                />
              </v-col>

              <v-col cols="6" v-if="'params' in item">
                <v-switch v-model="item.params.validate" label="validate" dense hide-details class="py-0 my-0" color="grey darken-3" />
              </v-col>

              <v-col cols="6">
                <v-switch
                  v-model="actionTooltip[index]"
                  label="tooltip"
                  dense
                  hide-details
                  class="py-0 my-0"
                  color="grey darken-3"
                  @change="toggleActionTooltip(item, index)"
                />
              </v-col>

              <v-col cols="6">
                <v-text-field label="Ordem" v-model="orderByFieldView" dense hide-details type="number" min="0" @input="orderByButtons(index)" />
              </v-col>

              <template v-if="actionTooltip[index]">
                <v-col cols="6">
                  <v-text-field class="mt-2" color="grey darken-3" label="tooltip" v-model="item.tooltip" dense hide-details />
                </v-col>

                <v-col cols="6">
                  <v-text-field class="mt-2" color="grey darken-3" label="tooltipColorClass" v-model="item.tooltipColorClass" dense hide-details />
                </v-col>
              </template>

              <v-col cols="6">
                <span class="text-subtitle-2 font-weight-medium grey--text text--darken-3">ActionType:</span>

                <v-radio-group class="pb-0 my-0" v-model="actionType[index]" dense hide-details @change="onChangeActionType(item, index)">
                  <v-radio class="mb-1" color="grey darken-3" label="redirect" value="redirect" />
                  <v-radio class="mb-1" color="grey darken-3" label="procedure" value="procedure" />
                  <v-radio class="mb-1" color="grey darken-3" label="component" value="component" />
                  <v-radio class="mb-1" color="grey darken-3" label="report" value="report" />
                  <v-radio class="mb-1" color="grey darken-3" label="excel" value="excel" />
                  <v-radio class="mb-1" color="grey darken-3" label="txt" value="txt" />
                  <v-radio class="mb-1" color="grey darken-3" label="ECM" value="ecm" />
                </v-radio-group>
              </v-col>

              <v-col cols="6" v-if="'procedure' in item || 'component' in item">
                <v-switch
                  v-model="after[index]"
                  label="After"
                  dense
                  hide-details
                  class="pt-0 mt-0"
                  color="grey darken-3"
                  @change="toggleAfter(item, index)"
                />

                <br />

                <v-switch
                  v-model="before[index]"
                  label="Before"
                  dense
                  hide-details
                  class="pt-0 mt-0"
                  color="grey darken-3"
                  @change="toggleBefore(item, index)"
                />
              </v-col>

              <v-col cols="12" class="pb-2" v-if="actionType[index] === 'procedure'">
                <v-text-field
                  v-if="'procedure' in item"
                  label="Procedure"
                  :value="item.procedure.name"
                  @change="handleChangeActionProcedure($event, index)"
                  color="grey darken-3"
                  dense
                  hide-details
                />
              </v-col>

              <v-col cols="12" class="py-1" v-if="actionType[index] === 'redirect'">
                <devContainerOfPanel
                  :schema="{
                    type: 'devContainerOfPanel',
                    model: 'redirect',
                    component: 'dev-simple-object-attr',
                    styleClasses: 'col-12',
                    title: 'Redirect'
                  }"
                  :model="{ redirect: item.redirect }"
                />
              </v-col>

              <v-col cols="12" class="py-1" v-if="actionType[index] === 'component'">
                <devContainerOfPanel
                  v-if="'component' in item"
                  :schema="{
                    type: 'devContainerOfPanel',
                    model: 'component',
                    component: 'dev-simple-object-attr',
                    styleClasses: 'col-12',
                    title: 'Component'
                  }"
                  :model="{ component: item.component.params }"
                />
              </v-col>

              <v-col cols="12" class="py-1" v-if="actionType[index] === 'ecm'">
                <devContainerOfPanel
                  :schema="{
                    type: 'devContainerOfPanel',
                    model: 'ecm',
                    component: 'dev-simple-object-attr',
                    styleClasses: 'col-12',
                    title: 'ECM'
                  }"
                  :model="{ ecm: item.ecm }"
                />
              </v-col>

              <v-col cols="12" class="py-1" v-if="actionType[index] === 'report'">
                <devContainerOfPanel
                  :schema="{
                    type: 'devContainerOfPanel',
                    model: 'report',
                    component: 'dev-simple-object-attr',
                    styleClasses: 'col-12',
                    title: 'Report'
                  }"
                  :model="{ report: item.report }"
                />
              </v-col>

              <v-col cols="12" class="py-1" v-if="actionType[index] === 'excel'">
                <devContainerOfPanel
                  :schema="{
                    type: 'devContainerOfPanel',
                    model: 'excel',
                    component: 'dev-simple-object-attr',
                    styleClasses: 'col-12',
                    title: 'Excel'
                  }"
                  :model="{ excel: item.excel }"
                />
              </v-col>

              <v-col cols="12" class="py-1" v-if="actionType[index] === 'txt'">
                <devContainerOfPanel
                  :schema="{
                    type: 'devContainerOfPanel',
                    model: 'txt',
                    component: 'dev-simple-object-attr',
                    styleClasses: 'col-12',
                    title: 'Txt'
                  }"
                  :model="{ txt: item.txt }"
                />
              </v-col>

              <v-col cols="12" class="py-1" v-if="after[index] && (actionType[index] === 'procedure' || actionType[index] === 'component')">
                <devContainerOfPanel
                  :schema="{
                    type: 'devContainerOfPanel',
                    model: 'after',
                    component: 'dev-simple-object-attr',
                    styleClasses: 'col-12',
                    title: 'After'
                  }"
                  :model="{ after: item.after }"
                />
              </v-col>

              <v-col cols="12" class="py-1" v-if="before[index] && (actionType[index] === 'procedure' || actionType[index] === 'component')">
                <devContainerOfPanel
                  :schema="{
                    type: 'devContainerOfPanel',
                    model: 'before',
                    component: 'dev-simple-object-attr',
                    styleClasses: 'col-12',
                    title: 'Before'
                  }"
                  :model="{ before: item.before }"
                />
              </v-col>

              <v-col cols="12" class="py-1" v-if="confirmMessage[index]">
                <devContainerOfPanel
                  :schema="{
                    type: 'devContainerOfPanel',
                    model: 'confirmMessage',
                    component: 'dev-simple-object-attr',
                    styleClasses: 'col-12',
                    title: 'confirmMessage'
                  }"
                  :model="{ confirmMessage: item.confirmMessage }"
                />
              </v-col>

              <v-col cols="12" class="py-1">
                <devContainerOfPanel
                  :schema="{
                    type: 'devContainerOfPanel',
                    model: 'attributes',
                    component: 'dev-attr-crud-vuetify',
                    styleClasses: 'col-12',
                    title: 'Attributes'
                  }"
                  :model="{ attributes: item.attributes }"
                />
              </v-col>

              <v-col cols="12" class="pt-1 pb-0">
                <devContainerOfPanel
                  :schema="{
                    type: 'devContainerOfPanel',
                    model: 'attributesIcon',
                    component: 'dev-attr-crud-vuetify',
                    styleClasses: 'col-12',
                    title: 'Attributes Icon'
                  }"
                  :model="{ attributesIcon: item.attributesIcon }"
                />
              </v-col>
            </v-row>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card>
</template>

<script>
import eventBus from 'vue-option-events';
import { randomString } from '@/helpers/dev';
import * as HANDLERS from '@/helpers/types/handlers';

const INITIAL_ITEM = {
  label: 'Button',
  id: '',
  name: '',
  actionName: '',
  visible: true,
  readonly: false,
  hasConditions: false,
  params: { validate: false },
  redirect: {
    page: '',
    mode: '',
    target: '',
    dialog: ''
  },
  attributes: {
    color: 'primary',
    dark: true
  },
  attributesIcon: {
    icon: 'home'
  }
};

const redirect = {
  page: '',
  mode: '',
  target: '',
  dialog: ''
};

const component = {
  params: {
    nameDll: '',
    namespace: '',
    className: '',
    methodName: ''
  }
};

const report = {
  reportId: '',
  fileName: ''
};

const excel = {
  reportId: ''
};

const txt = {
  reportId: ''
};

const ecm = {
  download: true,
  domain: 1,
  modelDocumentId: ''
};

const after = {
  updateMaster: true,
  update: true,
  page: false,
  tab: false,
  step: false,
  parameters: {
    tab: '',
    step: '',
    page: '',
    mode: '',
    keepSidebar: false,
    keepDialog: false,
    rootLevel: false
  }
};

const confirmMessage = {
  title: 'Deseja realmente executar esta ação?',
  text: 'text',
  type: 'warning',
  showCancelButton: true,
  confirmButtonText: 'Ok ',
  confirmButtonClass: 'success',
  cancelButtonText: 'Cancelar',
  cancelButtonClass: 'error',
  reverseButtons: true
};

export default {
  components: {
    devContainerOfPanel: () => import('@/components/dev/dev-container-of-panel')
  },

  props: {
    value: { type: [Object, Array], default: () => ({} || []) },
    model: { type: Object, default: () => ({}) },
    schema: { type: Object, default: () => ({}) }
  },

  data: () => ({
    after: [], // --> Valor padrão é "false"
    before: [], // --> Valor padrão é "false"
    actionType: [], // --> Valor padrão é "redirect"
    confirmMessage: [], // --> Valor padrão é "false"
    actionTooltip: [], // --> Valor padrão é "false"
    orderByFieldView: 0
  }),

  mounted() {
    const _vm = this;

    _vm.after = [];
    _vm.before = [];
    _vm.actionType = [];
    _vm.confirmMessage = [];
    _vm.actionTooltip = [];

    _vm.value.map((item, index) => {
      'confirmMessage' in item ? (_vm.confirmMessage[index] = true) : (_vm.confirmMessage[index] = false);
      'after' in item ? (_vm.after[index] = true) : (_vm.after[index] = false);
      'before' in item ? (_vm.before[index] = true) : (_vm.before[index] = false);

      'redirect' in item && (_vm.actionType[index] = 'redirect');
      'component' in item && (_vm.actionType[index] = 'component');
      'procedure' in item && (_vm.actionType[index] = 'procedure');
      'report' in item && (_vm.actionType[index] = 'report');
      'excel' in item && (_vm.actionType[index] = 'excel');
      'txt' in item && (_vm.actionType[index] = 'txt');
      'ecm' in item && (_vm.actionType[index] = 'ecm');

      'tooltip' in item ? (_vm.actionTooltip[index] = true) : (_vm.actionTooltip[index] = false);
    });
  },

  computed: {
    currentMode() {
      return this.$store.getters['dev/getCurrentMode'];
    }
  },

  methods: {
    handleChangeActionProcedure(e, index) {
      this.value[index].procedure.name = e;
    },

    onChangeActionType(item, index) {
      if (this.actionType[index] === 'redirect') {
        delete item.procedure;
        delete item.component;
        delete item.report;
        delete item.excel;
        delete item.ecm;
        delete item.txt;
        delete item.after;
        delete item.before;
        this.after[index] = false;
        this.before[index] = false;

        item.redirect = redirect;
      }

      if (this.actionType[index] === 'procedure') {
        delete item.redirect;
        delete item.component;
        delete item.report;
        delete item.excel;
        delete item.ecm;
        delete item.after;
        delete item.txt;
        delete item.before;
        this.after[index] = false;
        this.before[index] = false;

        item.procedure = { name: '' };
      }

      if (this.actionType[index] === 'component') {
        delete item.redirect;
        delete item.procedure;
        delete item.report;
        delete item.excel;
        delete item.ecm;
        delete item.after;
        delete item.txt;
        delete item.before;
        this.after[index] = false;
        this.before[index] = false;

        item.component = component;
      }

      if (this.actionType[index] === 'report') {
        delete item.redirect;
        delete item.procedure;
        delete item.component;
        delete item.ecm;
        delete item.excel;
        delete item.after;
        delete item.txt;
        delete item.before;
        this.after[index] = false;
        this.before[index] = false;

        item.report = report;
      }

      if (this.actionType[index] === 'excel') {
        delete item.redirect;
        delete item.procedure;
        delete item.component;
        delete item.ecm;
        delete item.report;
        delete item.after;
        delete item.before;
        delete item.txt;
        this.after[index] = false;
        this.before[index] = false;

        item.excel = excel;
      }

      if (this.actionType[index] === 'txt') {
        delete item.redirect;
        delete item.procedure;
        delete item.component;
        delete item.ecm;
        delete item.report;
        delete item.after;
        delete item.before;
        this.after[index] = false;
        this.before[index] = false;

        item.txt = txt;
      }

      if (this.actionType[index] === 'ecm') {
        delete item.redirect;
        delete item.procedure;
        delete item.component;
        delete item.report;
        delete item.excel;
        delete item.after;
        delete item.txt;
        delete item.before;
        this.after[index] = false;
        this.before[index] = false;

        item.ecm = ecm;
      }
    },

    handleAddNewItem() {
      this.after.push(false);
      this.before.push(false);
      this.actionType.push('redirect');
      this.confirmMessage.push(false);
      this.actionTooltip.push(false);

      INITIAL_ITEM.id = randomString();

      INITIAL_ITEM.name = INITIAL_ITEM.id;

      INITIAL_ITEM.actionName = `${this.currentMode}-model-here?`;

      this.value.push(JSON.parse(JSON.stringify(INITIAL_ITEM)));
    },

    handleRemoveItem(index) {
      this.value.splice(index, 1);
    },

    toggleConfirmMessage(item, index) {
      if (this.confirmMessage[index]) {
        item.confirmMessage = confirmMessage;

        return;
      }

      delete item.confirmMessage;
    },

    toggleActionTooltip(item, index) {
      if (this.actionTooltip[index]) {
        item.tooltip = 'Lorem Ipsum!';
        item.tooltipColorClass = '';
      }

      if (!this.actionTooltip[index]) {
        delete item.tooltipColorClass;
        delete item.tooltip;
      }

      eventBus.$emit(HANDLERS.RELOAD_COMPONENT_DEV);
    },

    toggleAfter(item, index) {
      if (this.after[index]) {
        item.after = after;

        return;
      }

      delete item.after;
    },

    toggleBefore(item, index) {
      if (this.before[index]) {
        item.before = before;

        return;
      }

      delete item.before;
    },

    orderByButtons(index) {
      let copy = this.model.items[index];

      this.model.items.splice(index, 1);
      this.model.items.splice(this.orderByFieldView, 0, copy);

      eventBus.$emit(HANDLERS.RELOAD_COMPONENT_DEV);
    },

    changeInputOrderBy(index) {
      this.orderByFieldView = index;
    }
  }
};
</script>
